import { render, staticRenderFns } from "./ActiveQueueReport.vue?vue&type=template&id=3d8b324e&"
import script from "./ActiveQueueReport.vue?vue&type=script&lang=js&"
export * from "./ActiveQueueReport.vue?vue&type=script&lang=js&"
import style0 from "./ActiveQueueReport.vue?vue&type=style&index=0&id=3d8b324e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports